<script>
import {mapState} from "vuex";
import i18n from "@/i18n";
import {query} from "@sinao/core-js";
import { VueTelInput } from 'vue-tel-input';
import ModalCreateOrganizationApiContent from "@/components/CreateOrganization/ModalCreateOrganizationApiContent.vue";
import ModalCreateOrganizationManualContent from "@/components/CreateOrganization/ModalCreateOrganizationManualContent.vue";
import onboardingPopoverMixin from "@/mixins/onboardingPopoverMixin";

export default {
  components: {
    VueTelInput,
    ModalCreateOrganizationApiContent,
    ModalCreateOrganizationManualContent
  },
  mixins: [onboardingPopoverMixin],
  props: {
    status: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      modalRefName: "ModalCreateOrganization",
      automatic_mode: true
    };
  },
  computed: {
    ...mapState({
      appId: state => state.app.id,
      loadingContact: state => state.contacts.loadingContact,
      editableContact: state => state.contacts.editableContact,
    }),
    currentContentComponent() {
      return this.automatic_mode ? 'ModalCreateOrganizationApiContent' : 'ModalCreateOrganizationManualContent';
    }
  },
  mounted() {
  },
  methods: {
    closed() {
      this.onModalHidden();
      this.$store.commit('showCreateOrganizationModal', false)
      this.$store.commit("renderGA", false);
      this.$store.commit('resetEditableContact');
      this.$store.commit('resetEditableEstablishment');
    },
    save() {
      if (!this.automatic_mode) {
        this.$refs.createOrganizationContent?.createOrganization();
      }
    },
    opened() {
      this.onModalShow();
      this.$store.commit("renderGA", true);
    }
  }
};
</script>

<template>
    <b-modal
        id="ModalCreateOrganization"
        :ref="modalRefName"
        :visible="status"
        :ok-only="true"
        centered
        header-class="bg-modal-contact"
        :footer-class="{'bg-modal-contact': true, 'd-none': automatic_mode}"
        size="sm"
        @close="closed"
        content-class="shadow"
        @hide="closed"
        @shown="opened"
    >
      <template #modal-header>
        <!-- Emulate built in modal header close button action -->
        <b-container style="max-width: 660px">
          <b-row>
            <b-col cols="11" class="pl-0">
              <b-container class="p-0">
                <b-row class="p-0">
                  <b-col cols="1" style="margin-top: -0.3rem"><span class="d-none d-sm-block" style="font-size: 1.2rem"><b-icon icon="building" /></span></b-col>
                  <b-col cols="11" class="pl-lg-0"><h5 style="margin: 0px">{{ $t('Ajouter une entreprise') }}</h5></b-col>
                </b-row>
              </b-container>
            </b-col>
            <b-col cols="1 text-right pr-0">
              <div class="close_icon icon_square text-center" @click="closed">
                <b-icon icon="x" font-scale="0.9" class="px-0" />
              </div>
            </b-col>
          </b-row>
          <b-row v-if="automatic_mode">
            <b-col class="text-xs text-muted my-1">
              {{ $t('Rechercher INSEE') }}
            </b-col>
          </b-row>
        </b-container>
      </template>
      <template #modal-footer>
        <!-- Emulate built in modal header close button action -->
        <b-container>
          <b-row>
            <b-col class="text-right">
              <s-button
                  type="border"
                  style="width: auto"
                  @click="automatic_mode=true"
              >
                {{ $t("Annuler") }}
              </s-button>
              <s-button
                  type="success"
                  style="width: auto"
                  class="ml-2"
                  :loading="loadingContact"
                  :disabled="loadingContact || !editableContact.name || !editableContact.type"
                  @click="save"
              >
                {{ $t("Ajouter") }}
              </s-button>
            </b-col>
          </b-row>
        </b-container>
      </template>

      <keep-alive>
        <component
            ref="createOrganizationContent"
            :is="currentContentComponent"
            :mode.sync="automatic_mode"
            @close="$emit('close')"
        />
      </keep-alive>

    </b-modal>
</template>

<style>
  .bg-modal-contact {
     background-color: #f4f6f9 !important;
   }

  @media screen and (max-width: 750px) {
    #ModalCreateOrganization .modal-dialog {
      margin: 0;
      max-width: 100%;
      height: 80vh;
      max-height: 80vh;
    }
    #ModalCreateOrganization .modal-content {
      height: 80vh;
      max-height: 80vh;
      border-radius: 0;
      display: flex;
      flex-direction: column;
    }
    #ModalCreateOrganization .modal-header {
      flex-shrink: 0;
    }
    #ModalCreateOrganization .modal-body {
      flex: 1 1 0;
      min-height: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    #ModalCreateOrganization .modal-footer {
      flex-shrink: 0;
    }
  }

  .close_icon {
    border-radius: 50%;
    background-color: #e4eaf2;
    padding: 0;
    font-weight: bold;
    float: right;
    margin-top: -0.3rem;
    cursor: pointer;
  }
  .icon_square {
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    line-height: 1.8rem;
    font-size: 1.6rem;
  }
  .icon_small {
    width: 1.6rem;
    height: 1.6rem;
    line-height: 1.6rem;
    margin-top: 0.15rem;
    font-weight: lighter;
  }
  .text_icon {
    font-weight: 200;
    font-size: 1rem;
  }
  .text_or {
    font-weight: 100;
    font-size: 0.85rem;
  }
</style>
